import React from "react";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import { useNavigate } from "react-router-dom";
import { RouteNames } from "../router/RouteNames";
import { customColors } from "../util/Theme";

export const Navbar = () => {
  const navigate = useNavigate();

  return (
    <AppBar
      position="static"
      elevation={0}
      sx={{
        borderBottom: `2px solid ${customColors.foreground}`,
      }}
    >
      <Toolbar
        sx={{
          maxWidth: 1300,
          width: "100%",
          margin: "0 auto",
          padding: "0 24px",
        }}
      >
        <Typography
          variant="h6"
          noWrap
          sx={{
            fontWeight: 700,
            marginRight: "72px",
          }}
        >
          Florian Chen
        </Typography>
        <Typography
          variant="h6"
          noWrap
          sx={{
            cursor: "pointer",
            fontWeight: 500,
            marginRight: "32px",
            "&:hover": {
              textDecoration: "underline",
            },
          }}
          onClick={() => navigate(RouteNames.ROOT)}
        >
          About Me
        </Typography>
        <Typography
          variant="h6"
          noWrap
          sx={{
            cursor: "pointer",
            fontWeight: 500,
            "&:hover": {
              textDecoration: "underline",
            },
          }}
          onClick={() => window.location.assign(RouteNames.CV)}
        >
          CV
        </Typography>
      </Toolbar>
    </AppBar>
  );
};
